import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-limit-warning',
  standalone: false,
  templateUrl: './limit-warning.component.html',
  styleUrl: './limit-warning.component.scss'
})
export class LimitWarningComponent {

  public data = inject(NZ_MODAL_DATA) as { limit: number };

  constructor(private dialogRef: NzModalRef<LimitWarningComponent>) { }

  public onCloseModal(): void {
    this.dialogRef.close();
  }
}
